import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=4c6eec72"
import script from "./PromotionList.vue?vue&type=script&lang=js"
export * from "./PromotionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports